// extracted by mini-css-extract-plugin
module.exports = {"InputDropdown":"_14LtwDxdhitaeOQnY3FbJ8","Message":"_1HjfLaKfLSo1ueTlDFRZip"};